(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('EstadoactualDetailController', EstadoactualDetailController);

    EstadoactualDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Estadoactual'];

    function EstadoactualDetailController($scope, $rootScope, $stateParams, previousState, entity, Estadoactual) {
        var vm = this;

        vm.estadoactual = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:estadoactualUpdate', function(event, result) {
            vm.estadoactual = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
